module.exports = __webpack_public_path__ + "img/172.e9a07c18.jpg";